import { BoxDemo } from "./BoxDemo";
import { IconViewDemo } from "./IconViewDemo";
import { SurfaceDemo } from "./SurfaceDemo";
import { TableLinearDemo } from "./TableLinearDemo";
import { TableTreeDemo } from "./TableTreeDemo";
import { TabViewDemo } from "./TabViewDemo";
import { ToolbarDemo } from "./ToolbarDemo";

export function ContainersData() {
	return (
		<section id="containers-data" className="demo-category">
			<h1>Containers & Data</h1>
			<BoxDemo />
			<SurfaceDemo />
			<ToolbarDemo />
			<TabViewDemo />
			<section id="table-group">
				<h2>Table view</h2>
				<TableLinearDemo />
				<TableTreeDemo />
			</section>
			<IconViewDemo />
		</section>
	);
}
